import {useMediaQuery} from '@mui/material';
import {useTheme} from '@mui/system';
import {useFetch} from 'api/api';
import {useEffect, useMemo, useState} from 'react';
import BinanceIcon from 'assets/images/svg/crypto/binance.svg';
import BitcoinIcon from 'assets/images/svg/crypto/bitcoin.svg';
import ETHIcon from 'assets/images/svg/crypto/eth.svg';
import RippleIcon from 'assets/images/svg/crypto/ripple.svg';
import TetherIcon from 'assets/images/svg/crypto/tether.svg';

const TopTokenInfo = () => {
  function createData(icon, crypto, price, percentageChange, marketCap) {
    return {icon, crypto, price, percentageChange, marketCap};
  }

  const [btc, setBtc] = useState();
  const [eth, setEth] = useState();
  const [usdt, setUsdt] = useState();
  const [xrp, setXrp] = useState();
  const [bnb, setBnb] = useState();
  const {data: dataFetch, loading: Loading} = useFetch([
    'get',
    'tokens/default?symbols=BTC,ETH,USDT,XRP,BNB',
  ]);
  const {data: dataXrp} = useFetch([
    'get',
    'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=ripple&order=market_cap_desc&per_page=100&page=1&sparkline=false',
  ]);
  useEffect(() => {
    const data = dataFetch?.data;
    const indexBtc = data?.findIndex((el) => el.symbol.toUpperCase() == 'BTC');
    const indexEth = data?.findIndex((el) => el.symbol.toUpperCase() == 'ETH');
    const indexBnb = data?.findIndex((el) => el.symbol.toUpperCase() == 'BNB');
    const indexXrp = data?.findIndex((el) => el.symbol.toUpperCase() == 'XRP');
    const indexUsdt = data?.findIndex(
      (el) => el.symbol.toUpperCase() == 'USDT',
    );
    if (indexBtc >= 0) {
      setBtc(data[indexBtc]);
    }
    if (indexEth >= 0) {
      setEth(data[indexEth]);
    }
    if (indexBnb >= 0) {
      setBnb(data[indexBnb]);
    }
    if (dataXrp?.length > 0) {
      setXrp(dataXrp[0]);
    }
    if (indexUsdt >= 0) {
      setUsdt(data[indexUsdt]);
    }
  }, [dataFetch?.data, dataXrp]);
  const rows = useMemo(() => {
    return [
      createData(
        BitcoinIcon,
        'Bitcoin (BTC)',
        btc?.last_price || 0,
        btc ? parseFloat(btc['24h_change']).toFixed(2) : 0,
        Math.abs(btc?.market_cap) >= 1.0e9
          ? (Math.abs(Number(btc?.market_cap)) / 1.0e9).toFixed(2) + 'B'
          : btc?.market_cap,
      ),
      createData(
        ETHIcon,
        'Ethereum (ETH)',
        eth?.last_price || 0,
        eth ? parseFloat(eth['24h_change']).toFixed(2) : 0,

        Math.abs(eth?.market_cap) >= 1.0e9
          ? (Math.abs(Number(eth?.market_cap)) / 1.0e9).toFixed(2) + 'B'
          : eth?.market_cap,
      ),
      createData(
        TetherIcon,
        'Tether (USDT)',
        usdt?.last_price || 0,
        usdt ? parseFloat(usdt['24h_change']).toFixed(2) : 0,

        Math.abs(usdt?.market_cap) >= 1.0e9
          ? (Math.abs(Number(usdt?.market_cap)) / 1.0e9).toFixed(2) + 'B'
          : usdt?.market_cap,
      ),
      createData(
        RippleIcon,
        'Ripple (XRP)',
        xrp?.current_price || 0,
        xrp ? parseFloat(xrp?.price_change_percentage_24h).toFixed(2) : 0,

        Math.abs(xrp?.market_cap) >= 1.0e9
          ? (Math.abs(Number(xrp?.market_cap)) / 1.0e9).toFixed(2) + 'B'
          : xrp?.market_cap,
      ),
      createData(
        BinanceIcon,
        'Binance (BNB)',
        bnb?.last_price || 0,
        bnb ? parseFloat(bnb['24h_change']).toFixed(2) : 0,

        Math.abs(bnb?.market_cap) >= 1.0e9
          ? (Math.abs(Number(bnb?.market_cap)) / 1.0e9).toFixed(2) + 'B'
          : bnb?.market_cap,
      ),
    ];
  }, [dataXrp, eth, bnb, btc, usdt]);

  return rows;
};

export {TopTokenInfo};
